import { CommonModule } from '@angular/common';
import { Component, computed, inject, input } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CashPointSvgComponent } from 'src/app/components/cash-point-svg/cash-point-svg.component';
import { VariantViewerComponent } from "src/app/components/variant-viewer/variant-viewer.component";
import { IMAGE_URLS } from 'src/app/core/constants/image-source';
import { CategoryLayoutData } from 'src/app/core/interfaces/store-configuration.interface';
import { BrowserApiService } from 'src/app/core/services/browser-api/browser-api.service';
import { DeviceDetectionService } from 'src/app/core/services/device-detection/device-detection.service';
import { OverlayService } from 'src/app/core/services/overlay/overlay.service';
import { StoreConfigurationRepositoryService } from 'src/app/core/services/store-configuration/store-configuration-repository.service';
import { createDefaultCategoryLayoutData } from 'src/app/core/utilities/type-defaults.util';
import { DealCountdownService } from 'src/app/products/services/deal-countdown.service';
import { PriceService } from 'src/app/products/services/price.service';
import { CashpointsPipe } from 'src/app/shared/pipes/cashpoints.pipe';
import { IndianCurrencyPipe } from 'src/app/shared/pipes/indian-currency.pipe';
import { MathFloorPipe } from 'src/app/shared/pipes/math-floor.pipe';
import { ProductListingPercentageSavePipe } from 'src/app/shared/pipes/product-listing-percentage-save.pipe';
import { AddToCartActionComponent } from "../add-to-cart-action/add-to-cart-action.component";
import { ProductVariantManagementComponent } from '../product-varient-management/product-varient-management.component';


@Component({
  standalone: true,
  selector: 'product-card-rectangular',
  templateUrl: './product-card-rectangular.component.html',
  styleUrls: ['./product-card-rectangular.component.scss'],
  providers: [DealCountdownService],
  imports: [
    CommonModule,
    RouterModule,
    AddToCartActionComponent,
    CashPointSvgComponent,
    VariantViewerComponent,
    CashpointsPipe,
    IndianCurrencyPipe,
    MathFloorPipe,
    ProductListingPercentageSavePipe
  ]
})
export class ProductCardRectangularComponent extends ProductVariantManagementComponent {
  protected override router: Router;
  protected override priceService: PriceService;
  protected override overlayService: OverlayService;
  protected override browserApiService: BrowserApiService;
  protected override dealCountdownService: DealCountdownService = inject(DealCountdownService);
  private readonly deviceDetectionService = inject(DeviceDetectionService);
  private readonly storeConfigurationRepositoryService = inject(StoreConfigurationRepositoryService);

  IMAGE_URLS = IMAGE_URLS;



  readonly categoryLayoutData = input<CategoryLayoutData>(createDefaultCategoryLayoutData());


  // Expose device detection service signals for template usage
  get isMobile() {
    return this.deviceDetectionService.isMobile;
  }

  colorOptions = [
    {
      colorValue: '#cccccc',
      colorOptionsActive: true
    },
    {
      colorValue: '#62d468',
      colorOptionsActive: false
    },
    {
      colorValue: '#f15a15',
      colorOptionsActive: false
    },
  ]

  // Store configuration signal for cashpoints feature
  readonly storeConfiguration = computed(() => this.storeConfigurationRepositoryService.storeConfigurations());

  // Computed property for cash points
  readonly cashPoints = computed(() => {
    const priceList = this.productVariant?.price_list;
    if (!priceList) return 0;

    const cashpointsPipe = new CashpointsPipe();
    return cashpointsPipe.transform(priceList);
  });

  constructor() {
    // Get dependencies before calling super to avoid circular dependency
    const router = inject(Router);
    const priceService = inject(PriceService);
    const overlayService = inject(OverlayService);
    const browserApiService = inject(BrowserApiService);
    const dealCountdownService = inject(DealCountdownService);

    super(); // Call parent constructor

    // Parent class dependencies are now injected via inject() function
    this.router = router;
    this.priceService = priceService;
    this.overlayService = overlayService;
    this.browserApiService = browserApiService;
    this.dealCountdownService = dealCountdownService;
  }

  openProductPage(urlPath: string): void {
    window.open('/products/' + urlPath, '_blank', 'noopener');
  }

}

